import { apiRequest } from '../../../shared/api/client';
import { authResponseSchema } from '../../../entities/user/api/schemas';
import { requestPhoneCodeResponseSchema } from './schemas';

export async function requestPhoneCodeApi(phone: string) {
  return apiRequest('/auth/phone/request-code', {
    method: 'POST',
    body: { phone },
    parse: requestPhoneCodeResponseSchema.parse,
  });
}

export async function verifyPhoneCodeApi(phone: string, code: string) {
  return apiRequest('/auth/phone/verify', {
    method: 'POST',
    body: { phone, code },
    parse: authResponseSchema.parse,
  });
}

export async function requestPasswordOperationCodeApi(
  phone: string,
  operation: 'register' | 'recovery'
) {
  return apiRequest('/auth/password/request-code', {
    method: 'POST',
    body: { phone, operation },
    parse: requestPhoneCodeResponseSchema.parse,
  });
}

export async function loginWithPasswordApi(phone: string, password: string) {
  return apiRequest('/auth/password/login', {
    method: 'POST',
    body: { phone, password },
    parse: authResponseSchema.parse,
  });
}

export async function registerWithPasswordApi(
  phone: string,
  code: string,
  password: string
) {
  return apiRequest('/auth/password/register', {
    method: 'POST',
    body: { phone, code, password },
    parse: authResponseSchema.parse,
  });
}

export async function recoverPasswordApi(
  phone: string,
  code: string,
  newPassword: string
) {
  return apiRequest('/auth/password/recover', {
    method: 'POST',
    body: { phone, code, newPassword },
    parse: authResponseSchema.parse,
  });
}
